import { Injectable } from '@angular/core';
import { assign } from 'lodash';
import { Observable, Subject } from 'rxjs';

import { Toast } from '../interfaces/toast';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor() {}

  private toast = new Subject<any>();

  getToast(): Observable<any> {
    return this.toast.asObservable();
  }

  // May want to make this either throw or return an error.
  addErrorToast(
    header: string,
    body: string,
    options: {
      autohide?: boolean;
      delay?: number;
      returnError?: boolean;
      centerHeader?: boolean;
    } = {
      autohide: true,
      delay: 4000,
      returnError: false,
      centerHeader: false
    }
  ) {
    const {
      autohide = true,
      delay = 4000,
      returnError,
      centerHeader = false
    } = options;

    const toast = {
      header,
      body,
      autohide,
      class: 'toast-error',
      centerHeader
    } as Toast;

    if (autohide) {
      this.toast.next(assign(toast, { autohide, delay }));
    } else {
      this.toast.next(toast);
    }
    if (returnError) {
      return new Error(body);
    } else {
      return toast;
    }
  }

  addSuccessToast(
    header: string,
    body: string,
    options: { autohide?: boolean; delay?: number } = {
      autohide: true,
      delay: 3000
    }
  ) {
    const { autohide, delay } = options;
    const toast = {
      header,
      body,
      delay,
      autohide,
      class: 'toast-success'
    } as Toast;

    if (options.autohide) {
      this.toast.next(assign(toast, { autohide, delay }));
    } else {
      this.toast.next(toast);
    }

    return toast;
  }

  addToast(data: Toast) {
    this.toast.next(data);
  }
}
